import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Loader from 'shared/common/loader';
import './styles.scss';
import referralUndertakingService from './undertaking.service';

interface PropsType {}

const Undertaking: React.FC<PropsType> = () => {
  const location = useLocation();
  let investorId = new URLSearchParams(location.search).get('investorId');
  const [isConsented, setIsConsented] = useState(false);
  const [isRefValid, setIsRefValid] = useState(false);
  const [isRefNotfound, setIsRefNotfound] = useState(false);
  const [loading, setLoading] = useState(true);
  //   let investorId: any = 1234;

  const isRefCodeValid = async (invId: any) => {
    try {
      setLoading(true);
      const res = await referralUndertakingService.isReferralCodeValid(invId);
      if (res.status == 200) {
        if (res.data.data.isundertaking) {
          setIsRefValid(true);
          setLoading(false);
        } else {
          setIsRefValid(false);
          setLoading(false);
        }
      } else {
        toast.error('Something went wrong!');
        setLoading(false);
      }
    } catch (err: any) {
      setIsRefNotfound(true);
      console.log(err);
      setLoading(false);
    }
  };

  const submitFunc = async () => {
    try {
      const payload = {
        isundertaking: isConsented,
        investorId: investorId,
      };
      setLoading(true);
      const res = await referralUndertakingService.referralCodeUndertaking(
        payload
      );
      if (res.status == 200) {
        setIsRefValid(true);
        setLoading(false);
      }
    } catch (err: any) {
      console.log(err);
      setLoading(false);
      toast.error(err.data.errors[0].title);
    }
  };

  useEffect(() => {
    if (investorId) {
      isRefCodeValid(investorId);
    } else {
      setIsRefNotfound(true);
      setLoading(false);
    }
  }, [investorId]);

  return (
    <>
      <div className='undertaking-page mt-5'>
        <ToastContainer />
        {loading ? (
          <Loader />
        ) : (
          <>
            {isRefNotfound ? (
              <div className='container'>
                <div className='panel panel-default'>
                  <div className='panel-heading' id='headingOne'>
                    <h4 className='panel-title'>
                      <a aria-expanded='true'>Not Found!</a>
                    </h4>
                  </div>
                  <div className=''>
                    <div className='panel-body'>
                      <p>Sorry, the page you're looking for cannot be found.</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {isRefValid ? (
                  <div className='container'>
                    <div className='text-center text-bold mb-4 tit '>
                      {/* <h2>Lorem Ipsum</h2> */}
                    </div>

                    <div className='panel panel-default'>
                      <div className='panel-heading' id='headingOne'>
                        <h4 className='panel-title'>
                          <a aria-expanded='true'>Thanks !</a>
                        </h4>
                      </div>
                      <div>
                        <div className='panel-body'>
                          <p>Your response was submitted.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className='container'>
                    <div className='panel panel-default'>
                      <div className='panel-heading' id='headingOne'>
                        <h4 className='panel-title'>
                          <a
                            // role='button'
                            // data-toggle='collapse'
                            // data-parent='#accordion'
                            aria-expanded='true'
                            // aria-controls='collapseOne'
                          >
                            Terms and Conditions
                          </a>
                        </h4>
                      </div>
                      <div
                        // id='collapseOne'
                        className=''
                        // role='tabpanel'
                        // aria-labelledby='headingOne'
                      >
                        <div className='panel-body'>
                          <p>
                            “By clicking ‘I Agree,’ you acknowledge that you
                            have reviewed the{' '}
                            <a
                              href='https://www.sebi.gov.in/media/press-releases/oct-2021/dealing-in-unregulated-products-by-sebi-registered-investment-advisers_53370.html'
                              target='_blank'
                              style={{
                                textDecoration: 'none',
                                fontWeight: '700',
                              }}
                            >
                              SEBI circular
                            </a>{' '}
                            and confirm that you are in compliance with its
                            regulations. Additionally, by clicking ‘I Agree,’
                            you confirm that you have read, understood, and
                            accepted all terms and conditions outlined in the
                            document{' '}
                            <a
                              href='https://ebullion-preprod.s3.ap-south-1.amazonaws.com/static_data/Referral+Partnership+Program+Agreement.pdf'
                              target='_blank'
                              style={{
                                textDecoration: 'none',
                                fontWeight: '700',
                              }}
                            >
                              Referral Partnership Program Agreement document
                              with eBullion Private Limited.{' '}
                            </a>
                            This action constitutes a binding and legal
                            representation of your consent to be bound by these
                            terms and conditions.”
                            <br />
                            <br />
                            <p>
                              If you have any questions or need further
                              clarification regarding the terms, please contact
                              us at{' '}
                              <a
                                href='mailto:support@ebullion.in'
                                style={{
                                  fontWeight: '700',
                                  textDecoration: 'none',
                                }}
                              >
                                support@ebullion.in
                              </a>
                            </p>
                          </p>
                          <div className='container_checkbox '>
                            <p>
                              <Form.Check
                                className=' '
                                style={{ color: '#99834d' }}
                                type='checkbox'
                                label={<>I Agree</>}
                                onClick={() => setIsConsented(!isConsented)}
                              ></Form.Check>
                            </p>
                            <div className='d-flex justify-content-end'>
                              <button
                                className='btn btn-primary'
                                disabled={!isConsented}
                                onClick={() => submitFunc()}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Undertaking;
